export default function ({ $dayjs, app }) {
    $dayjs.locale(app.i18n.locale)
}
